var NDJSON = function () {
  function NDJSON() {}
  NDJSON.stringify = function stringify(object) {
    return JSON.stringify(object) + '\n';
  };
  return NDJSON;
}();
export default NDJSON;